<div class="container loader-container" [hidden]="!isLoading">
	<div class="row">
		<div class="col-12 text-center">
			<svg xmlns="http://www.w3.org/2000/svg" class="loader mx-auto" viewBox="0 0 658 721.99"><g id="Layer_2" style="fill: #fff" data-name="Layer 2"><g id="Layer_1-2" style="fill: #fff" data-name="Layer 1"><path class="cls-1" d="M530,0H121L0,712H114L218,92H493c24,0,37,13,37,37s-13,37-37,37H254l-12,70c-18,116,21,166,120,166H465c24,0,38,13,38,37s-14,37-38,37H202l-12,70c-18,106,31,166,131,166H588V620H324c-42,0-63-28-55-74H505c75,0,118-43,118-118S580,310,505,310H377c-49,0-66-22-56-74H530c75,0,118-43,118-118S605,0,530,0Z"/></g></g></svg>
		</div>
	</div>
</div>
